import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderCarouselComponent } from './header-carousel.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BtnOneModule } from '../btn-one/btn-one.module';
import { TranslationModule } from 'src/app/i18n/translation.module';

@NgModule({
  declarations: [
    HeaderCarouselComponent
  ],
  imports: [
    CommonModule,
    CarouselModule,
    BtnOneModule,
    TranslationModule
  ],
  exports: [HeaderCarouselComponent]
})
export class HeaderCarouselModule { }
